export enum AdjustmentType {
    CustomerDeduction = 1,
    DotBillback = 2,
    CustomerDedRepay = 3,
    DotCreditToSupplier = 4,
    Discount = 5,
    Pricing = 6,
    Quantity = 7,
    SpecialPricing = 8,
    Invoice = 9,
}

export const AdjustmentTypeText: Record<AdjustmentType, string> = {
    [AdjustmentType.CustomerDeduction]: "Customer Deduction",
    [AdjustmentType.DotBillback]: "Dot Billback",
    [AdjustmentType.CustomerDedRepay]: "Customer Ded Repay",
    [AdjustmentType.DotCreditToSupplier]: "Dot Credit to Supplier",
    [AdjustmentType.Discount]: "Discount",
    [AdjustmentType.Pricing]: "Pricing",
    [AdjustmentType.Quantity]: "Quantity",
    [AdjustmentType.SpecialPricing]: "Special Pricing",
    [AdjustmentType.Invoice]: "Invoice",
};